<app-notification></app-notification>

<app-login-comp
  [error]="errormessage"
  (loginEvent)="onLogin($event)"
></app-login-comp>
